// Translation locales
import frZod from 'zod-i18n-map/locales/fr/zod.json'
import enZod from 'zod-i18n-map/locales/en/zod.json'

import enAbstracts from './en/abstracts.json'
import frAbstracts from './fr/abstracts.json'

import enAdmin from './en/admin.json'
import frAdmin from './fr/admin.json'

import enCommon from './en/common.json'
import frCommon from './fr/common.json'

import enDashboard from './en/dashboard.json'
import frDashboard from './fr/dashboard.json'

import enEvents from './en/events.json'
import frEvents from './fr/events.json'

import enLogin from './en/login.json'
import frLogin from './fr/login.json'

import enProfile from './en/profile.json'
import frProfile from './fr/profile.json'

export const resources = {
  en: {
    abstracts: enAbstracts,
    admin: enAdmin,
    common: enCommon,
    events: enEvents,
    dashboard: enDashboard,
    login: enLogin,
    profile: enProfile,
    zod: enZod,
  },
  fr: {
    abstracts: frAbstracts,
    admin: frAdmin,
    common: frCommon,
    events: frEvents,
    dashboard: frDashboard,
    login: frLogin,
    profile: frProfile,
    zod: frZod,
  },
} as const
